import { Environment } from '@environments/model';
import { LogLevel } from '@shared/services/logs';

export const environmentBase: Environment = {
  production: true,
  applicationType: 'PROD',
  isCacheEnabled: true,
  isMockEnabled: false, // ⚠️ If you wanna activate the mocks in production, remember to delete the fileReplacements that correspond to the mock.ts in the angular.json file (not recommended).
  logLevel: LogLevel.ERROR,
  API: {
    endpoint: {
      default: 'https://api.evoq.fourniergroupe.com/api/v1',
      evoqAdmin: 'https://admin.evoq.fourniergroupe.com/api/v1',
    },
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
  },
  tenants: {
    FRANCHISE: {
      authorizationEndpoint:
        'https://login.microsoftonline.com/c9fca1fb-f52e-4607-be25-910ae91ad780/oauth2/v2.0/authorize',
      clientId: 'cc63f164-06db-4379-ae8a-f7295a8ead9a',
    },
    GROUPE: {
      authorizationEndpoint:
        'https://login.microsoftonline.com/b84fabbe-c9cd-4e94-b1a7-cb953f3b7227/oauth2/v2.0/authorize',
      clientId: 'ce0036b4-f3d5-4ba7-9f2d-2297494510fe',
    },
  },
  CDN: {
    url: 'https://assets.evoq.fourniergroupe.com',
    rewrites: {
      images: {
        source: 'generated-images',
        target: 'evoq-images',
      },
      videos: {
        source: 'generated-videos',
        target: 'evoq-videos',
      },
    },
  },
  devTools: 'off',
  domains: {
    'evoq.perene.fr': {
      brand: 'perene',
      language: { default: 'fr', supported: ['fr'] },
    },
    'evoq.socooc.com': {
      brand: 'socooc',
      language: { default: 'fr', supported: ['fr'] },
    },
    'evoq.socooc.es': {
      brand: 'socooc',
      language: { default: 'es', supported: ['es', 'ca'] },
    },
    'evoq.mobalpa.fr': {
      brand: 'mobalpa',
      language: { default: 'fr', supported: ['fr'] },
    },
    'evoq.mobalpa.be': {
      brand: 'mobalpa',
      language: { default: 'fr-BE', supported: ['fr-BE', 'nl-BE'] },
    },
    'evoq.mobalpa.es': {
      brand: 'mobalpa',
      language: { default: 'es', supported: ['es', 'ca'] },
    },
    'evoq.hygena.com': {
      brand: 'hygena',
      language: { default: 'fr', supported: ['fr'] },
    },
  },
};
